module.exports = __webpack_public_path__ + "static/img/2-6.d239f63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/2-6.jpg
// module id = yKGs
// module chunks = 1